import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { openStripeElementModal } from "../utils/stripe_element_modal"

// Laisse voir la confirmation avant de refermer la modale.
const MODAL_CLOSE_DELAY_MS = 1200

// « Ajouter un moyen de paiement » (Mes paiements ou comptabilité) : SetupIntent dans une
// modale (PaymentMethodSetupsController), puis rechargement de la turbo-frame la plus proche
// ou morph de la page. Sans Stripe.js, le lien ouvre la session Checkout hébergée.
export default class extends Controller {
  static values = {
    setupUrl: String,
    modalTitle: String,
    submitLabel: String,
    successLabel: String,
    closeLabel: String,
    errorLabel: String
  }

  async open(event) {
    if (!this.setupUrlValue || typeof window.Stripe !== "function") return
    event.preventDefault()

    const modal = openStripeElementModal({
      title: this.modalTitleValue,
      closeLabel: this.closeLabelValue,
      submitLabel: this.submitLabelValue,
      withSummary: false
    })

    let data
    try {
      data = await this.postJson(this.setupUrlValue)
    } catch (error) {
      modal.showError(error.message)
      return
    }
    // Un SetupIntent non confirmé expire tout seul : rien à nettoyer si la modale est fermée.
    if (modal.hidden) return

    const stripe = window.Stripe(data.publishable_key, data.stripe_account ? { stripeAccount: data.stripe_account } : {})
    const elements = modal.mount({
      stripe,
      elementsOptions: { clientSecret: data.client_secret, locale: document.documentElement.lang || "fr" },
      paymentElementOptions: { defaultValues: { billingDetails: { email: data.email || "" } } }
    })

    modal.onSubmit(async () => {
      const { error, setupIntent } = await stripe.confirmSetup({
        elements,
        redirect: "if_required",
        // Seulement pour un moyen à redirection ; carte et SEPA restent dans la modale.
        confirmParams: { return_url: window.location.href }
      })
      if (error) throw new Error(error.message)
      if (!["succeeded", "processing"].includes(setupIntent?.status)) throw new Error(this.errorLabelValue)

      modal.showSuccess(this.successLabelValue)
      setTimeout(() => modal.hide(), MODAL_CLOSE_DELAY_MS)
      this.refreshAfterSuccess()
    })
  }

  refreshAfterSuccess() {
    let frame = this.element.closest("turbo-frame")
    while (frame) {
      const src = frame.getAttribute("src") || frame.dataset.src || frame.dataset.lazySrc
      if (src) {
        if (frame.getAttribute("src") && typeof frame.reload === "function") {
          frame.reload()
        } else {
          frame.setAttribute("src", src)
        }
        return
      }
      frame = frame.parentElement?.closest("turbo-frame")
    }

    Turbo.session.refresh(document.baseURI, { method: "morph", scroll: "preserve" })
  }

  async postJson(url) {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
      },
      body: "{}"
    })
    const data = await response.json().catch(() => ({}))
    if (!response.ok) throw new Error(data.error || this.errorLabelValue)
    return data
  }
}
